import React from 'react';
import PropTypes from 'prop-types';

import { schedulesInstructorsPropTypes } from 'constants/propTypes';
import { Autocomplete } from 'components/Form';

import messages from '../../ScheduleForm.messages';
import './SelectInstructorInput.scss';

const SelectInstructorInput = ({ instructors, onAddInstructorClick, ...rest }) => {
  const placeholder = messages.inputs.instructor.selectInstructor;
  const options = instructors
    .map(({ firstName, lastName, id }) => ({
      label: !lastName ? firstName : `${firstName} ${lastName}`,
      value: id,
    }))
    .concat({
      label: messages.inputs.instructor.add,
      value: 'add-instructor-class',
      isFilterable: false,
      labelProps: {
        className: 'select-instructor-input__add-instructor-button',
        onClick: () => onAddInstructorClick(),
      },
    });

  return <Autocomplete {...rest} placeholder={placeholder} options={options} />;
};

SelectInstructorInput.propTypes = {
  instructors: schedulesInstructorsPropTypes,
  onAddInstructorClick: PropTypes.func,
};

export default SelectInstructorInput;
